import type { CompanyPreviewPanelSurface } from "@/stores/company-preview-panel-store";
import { createContext, useContext, type ReactNode } from "react";

/**
 * The surface company mentions in this subtree open their side panel on. Defaults
 * to "sheet" (the viewport-anchored side sheet). A host that renders the panel in
 * its own bounds — the company-page chat when docked as a side panel, whose
 * preview must live within the chat's own component — provides "inline" so the
 * singleton sheet stands down.
 */
const CompanyPanelSurfaceContext = createContext<CompanyPreviewPanelSurface>("sheet");

export function CompanyPanelSurfaceProvider({
  surface,
  children,
}: {
  surface: CompanyPreviewPanelSurface;
  children: ReactNode;
}) {
  return (
    <CompanyPanelSurfaceContext.Provider value={surface}>
      {children}
    </CompanyPanelSurfaceContext.Provider>
  );
}

export function useCompanyPanelSurface(): CompanyPreviewPanelSurface {
  return useContext(CompanyPanelSurfaceContext);
}
